<template>
  <div>
    <confirm-dialog ref="confirmDeleteDialog"
                    confirm-button-color="deep-orange"
                    v-bind:cancel-button-label="$t('cancel')"
                    v-bind:confirm-button-label="$t('delete')"
                    v-bind:message="$t('areYouSureYouWantToDeleteThisCategoryIrrevocably')"
                    v-bind:title="$t('deleteCategory')"
                    v-model="confirmDeleteDialog" />

    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="title | defaultValue($t('category'))">
      <header-button icon="mdi-chevron-left"
                     slot="left-button"
                     v-bind:label="$t('back')"
                     v-bind:to="{ name: 'learning-categories' }" />

      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="updateCategory" />

      <v-menu slot="menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark
                 icon
                 v-bind="attrs"
                 v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-on:click="deleteCategory">
            <v-list-item-title class="deep-orange--text">{{ $t('delete') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container v-if="category != null">
      <v-row>
        <v-col cols="12"
               lg="6">
          <category-details-card ref="categoryDetailsCard"
                                v-bind:category="category" />
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import ConfirmDialog from '@/components/common/ConfirmDialog'
  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import CategoryDetailsCard from '@/components/learning/CategoryDetailsCard.vue'

  export default {
    async beforeRouteUpdate(to, from, next) {
      const id = parseInt(to.params.id)

      await this.get(id)

      next()
    },
    components: {
      ConfirmDialog,
      HeaderButton,
      CategoryDetailsCard,
      TopHeader
    },
    computed: {
      id() {
        return this.category?.id
      },
      title() {
        return this.category?.text
      },
      ...mapGetters({
        getCategory: 'learning/category'
      })
    },
    async created() {
      const id = parseInt(this.$route.params.id)

      await this.get(id)
    },
    data: () => ({
      confirmDeleteDialog: false,
      loading: false,
      category: null,
      validationSnackbar: false
    }),
    methods: {
      async deleteCategory() {
        await this.$refs.confirmDeleteDialog.open(async r => {
          if (!r) {
            return
          }

          this.loading = true

          await this.doDeleteCategory({ id: this.id })

          this.loading = false

          this.$router.push({ name: 'learning-categories' })
        })
      },
      async get(id) {
        this.loading = true

        await this.loadCategory({ id })

        this.loading = false

        this.category = Object.assign({}, this.getCategory(id))
      },
      async updateCategory() {
        if (!this.$refs.categoryDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        this.loading = true

        await this.doUpdateCategory({ category: this.category })

        this.loading = false

        this.$router.push({ name: 'learning-categories' })
      },
      ...mapActions({
        doDeleteCategory: 'learning/deleteCategory',
        doUpdateCategory: 'learning/updateCategory',
        loadCategory: 'learning/loadCategory'
      })
    },
    name: 'Category'
  }
</script>


<i18n>
  {
    "de": {
      "areYouSureYouWantToDeleteThisCategoryIrrevocably": "Sind Sie sicher, dass Sie diese Kategorie unwiderruflich löschen möchten?",
      "back": "Zurück",
      "cancel": "Abbrechen",
      "delete": "Löschen",
      "deleteCategory": "Kategorie löschen",
      "save": "Speichern",
      "category": "Kategorie",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "areYouSureYouWantToDeleteThisCategoryIrrevocably": "Are you sure you want to delete this category irrevocably?",
      "back": "Back",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleteCategory": "Delete category",
      "save": "Save",
      "category": "Category",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>